// extracted by mini-css-extract-plugin
export var cardContainer = "MediumPosts-module--card-container--c9f63";
export var cdsAssistiveText = "MediumPosts-module--cds--assistive-text--325b6";
export var cdsVisuallyHidden = "MediumPosts-module--cds--visually-hidden--2c5ab";
export var hideFeedback = "MediumPosts-module--hide-feedback--b03d5";
export var image = "MediumPosts-module--image--9892a";
export var showFeedback = "MediumPosts-module--show-feedback--a6c56";
export var skeleton = "MediumPosts-module--skeleton--2521e";